import React from "react";
import CircularProgress from '@mui/material/CircularProgress';

 const LoaderContainer: React.FC = () => {

  return (
    <div className="loader-container">
      <div className="absolute top-0 left-0 right-0 bottom-0 bg-[#DDD]/50  z-[1500]"></div>
      <div className="absolute top-2/4 left-2/4 z-[1501]" style={{transform: "translate(-50%, -50%)"}}>
        <CircularProgress sx={{width: "80px", height: "80px"}} />
      </div>
    </div>
  );
}

export default LoaderContainer;
